<template>
  <div>
    <div class="pa-5 pt-0 pb-0">
      <v-row style="justify-content:between">
        <v-col cols="12" sm="12" md="6" lg="6" class="sub-title">Drafts</v-col>
        <v-col class="pt-2" cols="12" sm="12" md="2" lg="2">
          <v-text-field
          class="mt-0"
          style="max-width:300px"
          v-model="selectedFilter.search"
          append-icon="search"
          label="Search"
          single-line
          hide-details>
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="2" lg="2" v-if="isSuperAdmin || isAM">
          <v-autocomplete
            :items="AM"
            item-value="id"
            item-text="name"
            label="AM"
            v-model="selectedFilter.AM"
            hide-details
            outlined
            dense
            @change="searchFilter"
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="12" md="2" lg="2" v-if="isSuperAdmin || isCC">
          <v-autocomplete
            :items="CC"
            item-value="id"
            item-text="name"
            label="CC"
            v-model="selectedFilter.CC"
            hide-details
            outlined
            dense
            @change="searchFilter"
          ></v-autocomplete>
        </v-col>
      </v-row>
    </div>
    <div class="pa-5 pt-2">
      <v-data-table
        class="drafts-data-table elevation-1"
        :loading="loading"
        :headers="headers"
        :items="filteredItems"
        :search="selectedFilter.search"
        :items-per-page="5"
      >
        <template v-slot:[`item.timeline`]="{ item }">
          <td :class="`text-center ${item.overdue ? 'overdue-highlight' : ''}`">
            <a
              class="custom-link"
              :href="`/campaigns/timeline?campaignID=${item.campaignID}`"
              :target="'_blank'"
              v-if="isLinkAllow"
            >
              {{item.startDate || ''}} - {{item.endDate || ''}}
            </a>
            <span v-else>{{item.startDate || ''}} - {{item.endDate || ''}}</span>
          </td>
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <td :class="`text-left ${item.overdue ? 'overdue-highlight' : ''}`">
            <a :href="`/influencers/invoices-brief-confirmation?id=${item.campaignID}`" :target="'_blank'" class="custom-link">{{item.name || ''}}</a>
          </td>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <td :class="`text-center ${item.overdue ? 'overdue-highlight' : ''}`">
            <a
            class="custom-link"
            :href="'/posts/internal/all-posts?campaignID='+item.campaignID"
            target="_blank">
              {{item.producedDeliverables || 0}} / {{item.pairingDeliverables || 0}}
            </a>
          </td>
        </template>
        <template v-slot:[`item.submissionDate`]="{ item }">
          <td :class="`text-center ${item.overdue ? 'overdue-highlight' : ''}`">
            <span>{{item.submissionDate ? formatDate(item.submissionDate) : ''}}</span>
          </td>
        </template>
        <template v-slot:[`item.reviewDate`]="{ item }">
          <td :class="`text-center pt-2 pb-2 ${item.overdue ? 'overdue-highlight' : ''}`">
            <div class="d-flex flex-row" style="justify-content:center">
              <v-text-field
                class="edit-date-box"
                placeholder="Review Date"
                v-model="item.reviewDate"
                outlined
                dense
                hide-details
                @input="checkDate(item, 'reviewDate', 'validReviewDate')"
                @keyup.enter="checkDate(item, 'reviewDate', 'validReviewDate', true)"
              >
              </v-text-field>
              <div class="date-picker-inner">
                <date-picker
                  className="input-field"
                  :options="{theme: 'icon', confirm: true}"
                  :status="item.reviewDateCal"
                  @changeDate="setDateFromPicker(item, 'reviewDate', ...arguments)"
                />
              </div>
            </div>
            <div v-if="item.validReviewDate === false">
              <span class="text-danger ma-0 pt-1">Invalid Start Date</span>
            </div>
          </td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>
<script>
import config from '@/config';
import campaignConfig from '../Campaign/config'
import DatePicker from '@/components/scoped/custom/DatePicker'
import utils from '@/utils'
import { mapState } from 'vuex'
import moment from 'moment';
export default {
  name: 'DraftsDataTable',
  components: {
    DatePicker
  },
  data() {
    return {
      headers: [
        {
          text: 'Deal Name',
          value: 'name',
          align: 'center'
        },
        {
          text: 'Timeline',
          value: 'timeline',
          align: 'center'
        },
        {
          text: 'Drafts status',
          value: 'status',
          align: 'center'
        },
        {
          text: 'Deadline for submission',
          value: 'submissionDate',
          align: 'center'
        },
        {
          text: 'Review date',
          value: 'reviewDate',
          align: 'center'
        }
      ],
      items: [],
      filteredItems: [],
      dashboardStatusDisplay: campaignConfig.dashboardStatusDisplay,
      selectedFilter: {
        AM: '',
        CC: ''
      },
      loading: false
    }
  },
  props: ['AM', 'CC'],
  computed: {
    ...mapState({
      dashboardCampaigns: state => state.campaign.dashboardDrafts,
      savedDashboardStatus: state => state.campaign.savedDashboardStatus
    }),
    isSuperAdmin: function() {
      return Number(this.$store.state.user.role) === config.userRoles.SUPER_ADMIN_HIGH
    },
    isAM: function() {
      return Number(this.$store.state.user.role) === config.userRoles.ACCOUNT_MANAGER
    },
    isCC: function() {
      return Number(this.$store.state.user.role) === config.userRoles.AD_STRATEGIST
    },
    currentUserRole: function () {
      return Number(this.$store.state.user.role)
    },
    currentUserID: function () {
      return this.$store.state.user.id
    },
    isLinkAllow: function() {
      return Number(this.$store.state.user.role) === config.userRoles.SUPER_ADMIN_HIGH ||
      Number(this.$store.state.user.role) === config.userRoles.SUPER_ADMIN_LOW ||
      Number(this.$store.state.user.role) === config.userRoles.ACCOUNT_MANAGER
    }
  },
  async mounted() {
    this.init()
    setTimeout(() => {
      this.setAMCC()
    }, 2000)
  },
  methods: {
    async init() {
      this.loading = true
      await this.$store.dispatch('campaign/getDashboardDrafts', {})
      this.items = this.dashboardCampaigns.map(d => d)
      this.filteredItems = this.items.map(item => item)
      this.loading = false
    },
    async updateData(item) {
      // change checkbox status
      await this.$store.dispatch('campaign/saveDashboardStatus', {
        id: item.id,
        type: config.dashboardTypes.drafts,
        reviewDate: item.reviewDate
      })
      this.init()
    },
    formatDate(date) {
      if (!date || date.includes('/')) return '';
      return moment(date).format('DD/MM/YYYY');
    },
    getDashboardStatusDisplay(status) {
      if (!status) return ''
      return this.dashboardStatusDisplay[status]
    },
    searchFilter() {
      this.filteredItems = this.items.map(i => i)
      if (this.selectedFilter.AM) {
        this.filteredItems = this.filteredItems.filter(item => (item.users && item.users.includes(this.selectedFilter.AM)))
      }
      if (this.selectedFilter.CC) {
        this.filteredItems = this.filteredItems.filter(item => (item.users && item.users.includes(this.selectedFilter.CC)))
      }
    },
    checkDate(item, fieldName, validFieldName, isUpdate) {
      // check date format if entered only
      item[validFieldName] = false
      const itemIdx = this.filteredItems.indexOf(item)
      if (utils.func.isDateFormatValid(item[fieldName]) || !item[fieldName]) {
        item[validFieldName] = true
        if (isUpdate) {
          this.updateData(item)
        }
      }
      this.filteredItems[itemIdx] = item
      this.filteredItems = utils.func.refreshJSON(this.filteredItems)
    },
    setDateFromPicker(item, fieldName, value) {
      const itemIdx = this.filteredItems.indexOf(item)
      this.filteredItems[itemIdx][fieldName] = utils.func.formatCustomDate(value, 'DD/MM/YYYY')
      this.filteredItems = utils.func.refreshJSON(this.filteredItems)
      this.updateData(item)
    },
    openCampaignModal(campaignID) {
      this.$emit('viewCampaign', campaignID)
    },
    setAMCC() {
      if (this.currentUserRole === config.userRoles.ACCOUNT_MANAGER) {
        let matchAM = this.AM.find(a => a.id === this.currentUserID)
        this.selectedFilter.AM = matchAM
      }
      if (this.currentUserRole === config.userRoles.AD_STRATEGIST) {
        this.selectedFilter.CC = this.currentUserID
      }
    }
  }
}
</script>
<style scoped>
  .edit-date-box {
    max-width: 200px;
  }
  .drafts-data-table .date-picker-inner {
    margin-left: -35px;
    padding-top: 3px;
  }
  .filter-area {
    justify-content: right;
  }
</style>



// WEBPACK FOOTER //
// DraftsDataTable.vue?cc7ddb76